export const OrderHistorySorting = {
  ByDate: 'Date',
  ByAmount: 'Amount',
  ByVoucherType: 'VoucherType'
};
